import { OntologyRolodexEntryType } from 'features/dynamicOntology'
import { RolodexHistogramFilter } from 'types'

export type MetricCalculationType = 'count' | 'sum' | 'min' | 'max' | 'mean'
export type FieldOperation = 'subtract' | 'add' | 'multiply' | 'divide'

export type FieldOperationGroup = {
  operation: FieldOperation
  field1: string
  field2: string
}

export type DrilldownMetricConfig = {
  metricType: string
  rolodexType: OntologyRolodexEntryType
  title: string
  // Calculation type (count, sum, min, max, mean)
  calculationType: MetricCalculationType
  // Field to aggregate (required for sum, min, max, mean)
  field?: string
  // Optional field operations to apply before aggregation
  fieldOperators?: readonly FieldOperationGroup[]
  filters?: ReadonlyArray<RolodexHistogramFilter>
  suffix?: string
  numDecimals?: number
  description?: string
}

// TODO @choikh: The metrics panel configs should be pulled from explorer state.
// Note: More complex cross-entry calculations are not supported yet.
// ex. multiplying one field from one entry with another field from another entry.
export const INDICATION_METRIC_CONFIGS: ReadonlyArray<DrilldownMetricConfig> = [
  {
    metricType: 'indication_count',
    rolodexType: 'indication',
    title: 'Number of Indications',
    calculationType: 'count',
    description: 'Total count of indications in the current filter',
  },
  {
    // Example of one layer operation
    metricType: 'circumferential_length_sum',
    rolodexType: 'indication',
    title: 'Circ Length Sum',
    calculationType: 'sum',
    fieldOperators: [
      {
        operation: 'subtract',
        field1: 'data.selection.y.end.num',
        field2: 'data.selection.y.start.num',
      },
    ],
    numDecimals: 3,
    description: 'Sum of all indication area',
  },
  {
    // Example of complex operation
    metricType: 'indication_area_sum',
    rolodexType: 'indication',
    title: 'Indication Area Sum',
    calculationType: 'sum',
    fieldOperators: [
      {
        operation: 'subtract',
        field1: 'data.selection.y.end.num',
        field2: 'data.selection.y.start.num',
      },
      {
        operation: 'subtract',
        field1: 'data.selection.x.end.num',
        field2: 'data.selection.x.start.num',
      },
      {
        operation: 'multiply',
        field1: 'result_0',
        field2: 'result_1',
      },
    ],
    numDecimals: 3,
    description: 'Sum of all circumferential lengths (end - start)',
  },
]

export const DEFAILT_AVAILABLE_METRIC_CONFIGS: ReadonlyArray<DrilldownMetricConfig> =
  [...INDICATION_METRIC_CONFIGS]
